import { Link } from 'gatsby';
import React from 'react';
import { AppControlContext } from '../../context/AppControlContext';
import { parseYouTubeVideoURL } from '../../utils/helper';
import { LinksButtonComponentStyles } from '../../utils/utils';
import Modal from '../Modal/refLibModal';

import './index.scss';

const CTALink = ({ text, linkTo, layoutStyle, openInNewTab, isYouTubeLink }) => {
  const { LinkModalIsOpen, setLinkModalIsOpen } = React.useContext(AppControlContext);

  const getLayoutStyle = (style) => {
    switch (style) {
      case LinksButtonComponentStyles.OUTLINE:
        return 'btn btn-outline';
      case LinksButtonComponentStyles.SOLID:
        return 'btn btn-solid';
      case LinksButtonComponentStyles.PRIMARY:
        return 'btn btn-primary';
      case LinksButtonComponentStyles.OUTLINE_ROTATE:
        return 'btn btn-outline rotate-45';
      case LinksButtonComponentStyles.SOLID_ROTATE:
        return 'btn btn-solid rotate-45';
      case LinksButtonComponentStyles.PRIMARY_ROTATE:
        return 'btn btn-primary rotate-45';
      case LinksButtonComponentStyles.OUTLINE_ICON:
        return 'btn btn-outline rotate-0';
      case LinksButtonComponentStyles.SOLID_ICON:
        return 'btn btn-solid rotate-0';
      case LinksButtonComponentStyles.PRIMARY_ICON:
        return 'btn btn-primary rotate-0';
      default:
        return LinksButtonComponentStyles.DEFAULT;
    }
  };

  const VideoLink = (props) => {
    const { link, title } = props;

    return (
      <>
        <a
          className={`${getLayoutStyle(layoutStyle)}`}
          onClick={() => {
            setLinkModalIsOpen({isopen:!LinkModalIsOpen,link:link});
          }}
          style={{ cursor: 'pointer' }}
        >
          {title}
        </a>
        {LinkModalIsOpen.isopen ? (
          <Modal isLink={true}>
            <iframe
              className=""
              src={parseYouTubeVideoURL(LinkModalIsOpen.link)}
              id="video"
              allowscriptaccess="always"
              allow="autoplay"
              title="ld"
              width="100%"
              height="400"
            />
          </Modal>
        ) : (
          ''
        )}
      </>
    );
  };
  return (
    <>
      {isYouTubeLink ? (
      
        <VideoLink key={linkTo} link={linkTo} title={text} />
      ) : (
        <Link target={openInNewTab && !isYouTubeLink ? '_blank' : ''} className={`${getLayoutStyle(layoutStyle)}`} to={linkTo}>
          {text}
          {typeof layoutStyle === 'string' && layoutStyle.includes('icon') && <i className="icon icon-arrow" />}
        </Link>
      )}
    </>
  );
};
export default CTALink;
